import { useEffect } from "react";

/**
 * useFTMessage()
 * 	This is a custom hook that handles connecting to the global message emitted by websockets
 * 	We wrap it in `useEffect()` so that we can import it and re-use it in other places in the app
 *
 *  Everything is wrapped in try/catch to prevent app breaking errors related to websockets
 *
 */

export default function useFTMessage(onEvent){
	useEffect(() => {
		try {
			window.addEventListener("onFTMessage", onEvent);
		} catch (err){}

		// By returning a function here, we can remove the eventListener when the component unmounts
		return function cleanup(){
			try {
				window.removeEventListener("onFTMessage", onEvent);
			} catch(err){}
		};
	}, [onEvent]);
}

export function useOnMountFTMessage(onEvent){
	useEffect(() => {
		try {
			window.addEventListener("onFTMessage", onEvent);
		} catch (err){}

		// By returning a function here, we can remove the eventListener when the component unmounts
		return function cleanup(){
			try {
				window.removeEventListener("onFTMessage", onEvent);
			} catch(err){}
		};
	}, []); // Only add the listener on mount
}
